const tra = {
  MIN_VALUE: {
    message: 'Transfer value can not be R$ 0,00',
    field: 'value',
    code: 'TRA_1'
  },
  MAX_VALUE: {
    message: 'Transfer value can not be greater than R$ {{maxValue}}',
    field: 'value',
    variable: 'maxValue',
    code: 'TRA_2'
  },
  FORMAT_ERROR: {
    message: 'Wrong content format of a transfer field',
    field: 'transfer',
    code: 'TRA_3'
  },
  PAYMENT_DATE_BEFORE_CURRENT_DATE: {
    message: 'Payment date before current date',
    field: 'payment_date',
    code: 'TRA_4'
  },
  INVALID_TEV_PROCESSING_HOUR: {
    message: 'Schedules for today are allowed until 7PM',
    field: 'payment_date',
    code: 'TRA_5'
  },
  INVALID_TED_PROCESSING_HOUR: {
    message: 'TED schedules for today are allowed until 4:30PM',
    field: 'payment_date',
    code: 'TRA_6'
  },
  MAX_PAYMENT_DATE: {
    message: 'You can not schedule a transfer after 30 days',
    field: 'payment_date',
    code: 'TRA_7'
  },
  BUSINESS_DAY: {
    message: 'We process transfers only on business days, change the date to a business day',
    field: 'payment_date',
    code: 'TRA_8'
  },
  PAYMENT_DATE_WRONG_DATE_FORMAT: {
    message: 'Wrong payment date format',
    field: 'payment_date',
    code: 'TRA_9'
  },
  NOT_SCHEDULED_OUT_OF_TIME: {
    message: 'You have payments that will be made on the next business day',
    field: 'payment_date',
    code: 'TRA_10'
  },
  DUPLICATED_INTEGRATION_ID: {
    message: 'Duplicated integration id',
    field: 'integration_id',
    code: 'TRA_11'
  },
  DBA_REMOVED: {
    message: 'Destination bank account is removed',
    field: 'destination_bank_account',
    code: 'TRA_12'
  },
  INVALID_PAYMENT_METHOD: {
    message: 'Invalid payment method',
    field: 'payment_method',
    code: 'TRA_13'
  },
  CANT_SCHEDULE_PIX_PAYMENT_WITH_KEY: {
    message: 'You cannot schedule a Pix payment with key',
    field: 'payment_date',
    code: 'TRA_14'
  },
  MAX_DECIMAL_PLACES: {
    message: 'Transfer value can not exceed 2 decimal places',
    field: 'value',
    code: 'TRA_15'
  },
  INVALID_PIX_DESCRIPTION_LENGTH: {
    message: 'Pix description can not be greater than 140 characters',
    field: 'pix_description',
    code: 'TRA_16'
  },
  INVALID_PIX_DESCRIPTION_FORMAT: {
    message: 'Invalid Pix description format',
    field: 'pix_description',
    code: 'TRA_17'
  },
  RECEIPT_BATCH_DOWNLOAD_LIMIT_EXCEEDED: {
    message:
      'More than {{maxTransfersAllowed}} transfers have been identified. Try applying more filters and try again.',
    field: 'receipt_batch_download',
    variable: 'maxTransfersAllowed',
    code: 'TRA_18'
  },
  INVALID_IDEMPOTENCY_KEY: {
    message: 'Invalid idempotency key',
    field: 'idempotency_key',
    code: 'TRA_19'
  },
  DUPLICATED_IDEMPOTENCY_KEY: {
    message: 'Transfer(s) with duplicated idempotency key ({{duplicatedIdempotencyKeys}})',
    field: 'idempotency_key',
    variable: 'duplicatedIdempotencyKeys',
    code: 'TRA_20'
  },
  INVALID_EMV: {
    message: 'Invalid Pix copy and paste (emv)',
    field: 'emv',
    code: 'TRA_21'
  },
  EMV_NOT_FOUND: {
    message: 'Unable to find Pix copy and paste (emv) data',
    field: 'emv',
    code: 'TRA_22'
  },
  INVALID_CITY_CODE: {
    message: 'Invalid city code',
    field: 'city_code',
    code: 'TRA_23'
  },
  EMV_ALREADY_PAID: {
    message: 'Pix copy and paste (emv) already paid',
    field: 'emv',
    code: 'TRA_24'
  },
  EMV_REMOVED: {
    message: 'Pix copy and paste (emv) removed by the receiver',
    field: 'emv',
    code: 'TRA_25'
  },
  DIVERGENT_EMV_VALUE: {
    message: 'The informed amount differs from the charge amount',
    field: 'emv',
    code: 'TRA_26'
  },
  DUE_DATE_EMV_NOT_SUPPORTED: {
    message: 'Due date collection payments are not supported',
    field: 'emv',
    code: 'TRA_27'
  },
  EXPIRED_EMV: {
    message: 'Expired Pix copy and paste (emv)',
    field: 'emv',
    code: 'TRA_28'
  },
  PIX_CHANGE_WITHDRAW_EMV_NOT_SUPPORTED: {
    message: 'Pix change and Pix withdraw are not supported',
    field: 'emv',
    code: 'TRA_29'
  }
};

module.exports = tra;
